// Download helper for AI Presence reports (client-side react-pdf, like
// consumerVoiceFiles.ts). Lazy requires keep the headless PDF harness importable.
import React from 'react';
import toast from 'react-hot-toast';
import { pdf } from '@react-pdf/renderer';
import { AiPresenceAudit, aipSubjectLabel } from '../../types/aiPresence';
import { AiPresencePdf } from './AiPresencePdf';
import { downloadBlob } from '../PdpAudit/reportFiles';

const slug = (v: string) =>
  v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'product';

export async function buildAiPresencePdfBlob(audit: AiPresenceAudit): Promise<Blob> {
  return pdf(React.createElement(AiPresencePdf, { audit }) as any).toBlob();
}

export function aiPresenceFileName(audit: AiPresenceAudit): string {
  const when = audit.scored_at ? audit.scored_at.slice(0, 10) : 'draft';
  return `AI-Audit-${slug(aipSubjectLabel(audit))}-${when}.pdf`;
}

// Fetches the detail (the list payloads omit `report`) and saves the PDF.
export async function downloadAiPresencePdf(detailEndpoint: string): Promise<void> {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const axiosInstant = require('../../api').default;
  const toastId = toast.loading('Preparing PDF…');
  try {
    const res = await axiosInstant.get(detailEndpoint);
    const audit = res.data as AiPresenceAudit;
    if (!audit || !audit.report) throw new Error('NoReport');
    const blob = await buildAiPresencePdfBlob(audit);
    downloadBlob(blob, aiPresenceFileName(audit));
    toast.success('Report downloaded', { id: toastId });
  } catch {
    toast.error("Couldn't build the report file. Please try again.", { id: toastId });
  }
}
